import { useState } from 'react';
import { useLazyFilterCaseContactsQuery } from '../../../graphql/graphql';

export default function useCaseContacts() {
	const [getCaseContactsQuery, { data, isLoading }] =
		useLazyFilterCaseContactsQuery();
	const [page, setPage] = useState(1);

	const getFlatWorkplaces = (filter: object) => {
		getCaseContactsQuery({
			...filter,
			skip: (page - 1) * 20,
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return {
		getFlatWorkplaces,
		getNextPage,
		data,
		isLoading,
		page,
		setPage,
	};
}
